import gql from 'graphql-tag'

export default gql`
    mutation SaveVZF($vzfID: String!, $input: VZFDataInput!) {
        saveVZF(vzfID: $vzfID, input: $input) {
            status
        }
    }
`
